module.exports = __webpack_public_path__ + "img/IMG-20191103-WA0007.abebdde2.jpg";